module.exports = __webpack_public_path__ + "static/media/wave.3930eb06.svg";